import React from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { Seo } from "@/components/Seo";

export default function Gallery() {
  const { data: shots = [] } = useQuery({ queryKey: ["gallery"], queryFn: async () => (await api.get("/gallery")).data });

  return (
    <div className="mx-auto max-w-[1600px] px-5 py-12 md:px-8" data-testid="gallery-page">
      <Seo title="Gallery — The Hoodie Project®" description="The community, the drops, the customs." />
      <div className="mb-10 border-b border-border pb-6">
        <p className="text-xs tracking-[0.3em] text-muted-foreground">THE LOOKBOOK</p>
        <h1 className="mt-3 font-display text-5xl font-extrabold tracking-tighter md:text-7xl">GALLERY</h1>
      </div>

      {shots.length === 0 ? (
        <p className="text-muted-foreground" data-testid="gallery-empty">No photos yet.</p>
      ) : (
        <div className="columns-1 gap-4 sm:columns-2 lg:columns-3">
          {shots.map((s) => (
            <div key={s.id} className="group relative mb-4 break-inside-avoid overflow-hidden border border-border" data-testid={`gallery-${s.id}`}>
              <img src={s.image} alt={s.caption} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" />
              {s.caption && <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/80 to-transparent p-4 text-xs tracking-widest">{s.caption}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
